// extracted by mini-css-extract-plugin
module.exports = {"container":"e_kx","up":"e_lx","down":"e_mx","percent":"e_nx","percentVal":"e_ox","title":"e_px","tags":"e_qx","textBadge":"e_rx"};